import React from 'react';
import { Building2, Lock } from 'lucide-react';
import { useAuth } from '../../../../context/AuthContext';

const InformacionPrincipal = ({ data, handlers }) => {
    const { user } = useAuth();
    const isSuperAdmin = user?.isSuperAdmin || user?.esSuperAdmin;

    return (
        <div className="bg-white rounded-2xl p-5 md:p-6 shadow-sm border border-slate-100">
            <div className="flex items-center gap-2 mb-4 border-b border-slate-100 pb-3">
                <Building2 className="w-4 h-4 text-blue-600" />
                <h2 className="text-base font-semibold text-slate-800">Datos Principales de la Junta</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Nombre de la Institución <span className="text-red-500">*</span></label>
                    <input 
                        type="text"
                        required
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        placeholder="Nombre oficial de la junta"
                        value={data.nombre}
                        onChange={(e) => handlers.setNombre(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Razón Social</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.razonSocial}
                        onChange={(e) => handlers.setRazonSocial(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Nombre Comercial</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.nombreComercial}
                        onChange={(e) => handlers.setNombreComercial(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">RUC</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.ruc}
                        onChange={(e) => handlers.setRuc(e.target.value)}
                    />
                </div>
                <div>
                    <label className="block text-xs font-medium text-slate-700 mb-1">Acuerdo Ministerial</label>
                    <input 
                        type="text"
                        className="w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm"
                        value={data.acuerdoMinisterial}
                        onChange={(e) => handlers.setAcuerdoMinisterial(e.target.value)}
                    />
                </div>
                <div>
                    <label className="flex items-center gap-1 text-xs font-medium text-slate-700 mb-1">
                        Fecha de Contrato 
                        {!isSuperAdmin && <Lock className="w-3 h-3 text-slate-400" title="Solo Superadmin puede editar" />}
                    </label>
                    <input 
                        type="date"
                        className={`w-full px-3 py-2 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm ${!isSuperAdmin ? 'bg-slate-50 text-slate-500 cursor-not-allowed' : ''}`}
                        value={data.fechaAcuerdo}
                        onChange={(e) => handlers.setFechaAcuerdo(e.target.value)}
                        disabled={!isSuperAdmin}
                    />
                </div>
            </div>
        </div>
    );
};

export default InformacionPrincipal;
